/**
 * Created by 310277742 on 08/01/2018.
 */
import { Idrug } from '../interfaces/drug.interface';

export class Drug implements Idrug {
  public name: string;
  public fdaStatusWithinIndication: string;
  public fdaStatusOutsideIndication: string;
  public fdaApprovedForIndication: boolean;
  public investigationalForIndication: boolean;
  public fdaApprovedOutsideIndication: boolean;
  public diseaseInOtherIndications: string[];
  public diseaseInThisIndication: string[];
  public id?: string;
  public gene?: string;
  public aberration?: string;
  public source?: string;
  public target?: string[];
  public drugIds?: any[];
  public drugBankVersion?: string;
  public therapeuticLevelOfEvidence?: string;
  public displayName?: string;

  constructor(init?: Partial<Drug>) {
    Object.assign(this, init);
  }

}
